<template>
  <div class="cursor-pointer" :class="[isFilterActive()?'bg-info rounded':'']" @click="setOrderSortFilter()">
    <slot></slot>
    <b-icon icon="caret-down-fill"/>
  </div>
</template>

<script>
import {mapGetters} from "vuex";

export default {
  name: "OrderTableFilter",
  props: {
    filterColumn: {
      default: 'id'
    },
  },
  data() {
    return {
      filterTypes: ['desc', 'asc'],
      filterTypeStatus: 0
    }
  },
  computed: {
    ...mapGetters({
      getFilters: 'ShoppingCart/getFilters'
    }),
    filterTypeComputed() {
      let filterType = this.filterTypes[this.filterTypeStatus];
      return `${this.filterColumn},${filterType}`
    }
  },
  methods: {
    toggleFilterTypeStatus() {
      if (this.filterTypeStatus === 0) {
        this.filterTypeStatus = 1
      } else {
        this.filterTypeStatus = 0
      }
    },
    setOrderSortFilter() {
      this.toggleFilterTypeStatus()
      this.$store.commit("ShoppingCart/setFilters", {key: "sort", value: this.filterTypeComputed});
      this.$store.dispatch("ShoppingCart/getAllOrders")
    },
    isFilterActive() {
      let filters = this.getFilters;
      if (Object.keys(filters).indexOf('sort')) {
        return filters['sort'] === this.filterTypeComputed
      }


      return false
    }
  },
}
</script>

<style scoped>
.cursor-pointer {
  cursor: pointer;
}
</style>